<template>
    <b-modal ref="profile_modal"
             size="xl"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">ID:{{this.item.uniq_id}}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">

                <b-overlay :show="is_load" rounded="sm">
                    <div class="panel-content">
                        <div class="d-flex flex-column align-items-center justify-content-center p-4">
                            <h5 class="mb-0 fw-700 text-center mt-3">
                                {{this.item.displayName}}
                                <small class="text-muted mb-0">
                                    {{__t('EMPLOY_INFO')}}
                                </small>
                            </h5>
                        </div>

                        <div>
                            <b-tabs content-class="mt-3" @input="tab_opened">
                                <b-tab v-for="(tab,index) in tabs" @click="set_active(index)"
                                       :disabled="tab.disabled"
                                       :title="get_tab_title(tab)"
                                       :key="index"
                                       :active="tab.is_active"
                                >
                                    <template slot="title">
                                        {{get_tab_title(tab)}}
                                        <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                                    </template>

                                    <component @on_change="change_atr" v-bind:is="tab.index" :item="item"></component>
                                </b-tab>
                            </b-tabs>
                        </div>
                        <div>
                        </div>
                    </div>

                </b-overlay>
            </div>
            <!--FOOTER -->
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">

                <button type="button" @click="remove()" class="btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5" v-if="item_id > 0">
                    {{ __t('REMOVE') }}
                </button>

                <button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
                    {{ __t('CLOSE') }}
                </button>

                <button type="button" v-on:click="save_employ" class="btn btn-primary waves-effect waves-themed">
                    {{ __t('SAVE') }}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import employ_info from "./tabs/employ_info.vue";
import employ_image from "./tabs/employ_image.vue";
import employ_tips from "./tabs/employ_tips.vue";

export default {
    name: "employ_modal",
    components : {
        employ_info,
        employ_image,
        employ_tips
    },
    props : {
        modal_position : {
            type : String,
            default : "right"
        },
    },
    data() {
        return {
            item_id : 0,
            item: {
                "id" : 0,
                "displayName" : "",
                "uniq_id" : "",
                'org_id' : 0,
                'middleName' : "",
                'firstName' : "",
                'lastName' : "",
                'short_code' : "",

                "pay_card" : "",
                'okpo' : "",
            },
            is_load: false,
            is_show_modal: false,
            tabs : []
        }
    },

    created () {
        EventBus.$on("employ_edit",res => this.work_click(res));
        EventBus.$on("close_employ",this.close);
    },

    methods : {

        work_click(item_id) {
            this.item_id = item_id;
            this.is_show_modal = true;
            this.load_employ();
        },

        tab_opened(tab) {
            EventBus.$emit("employ_tab",tab);
        },

        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },

        change_atr(atr_name,atr_val) {
            if(this.item.hasOwnProperty(atr_name)) {
                this.item[atr_name] = atr_val;
            }
        },

        set_active (obj) {
            for (let tab in this.tabs) {
                this.tabs[tab].is_active = false;
            }
            this.tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
        },

        save_employ () {
            EventBus.$emit('save_employ');
        },

        async remove() {
            let self = this;
            const is_ok = confirm_me(this.__t("ARE_SURE"));
            is_ok.then(res => {
                self.is_load = true;
                api.delete('/internal/v1/catalog/employees/'+ parseInt(this.item_id)).then(({data}) => {
                    self.is_load = false;
                    if (data.status === "operation_success") {
                        window.location.reload();
                    }
                }).catch(({response}) => {
                    self.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message, type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left"
                    })
                });
            });
        },

        close () {
            this.item = {
                "id" : 0,
                "displayName" : "",
                "uniq_id" : "",
                'org_id' : 0,
                'middleName' : "",
                'firstName' : "",
                'lastName' : "",
                'short_code' : "",
            };
            this.item_id = 0;

            this.tabs = [];
            this.is_show_modal = false;
        },

        async load_employ () {
            this.is_load = true;
            this.tabs = [];

            await api.get('/internal/v1/catalog/employees/' + this.item_id).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.item = data.data;
                    this.push_tabs();
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
            });
        },

        push_tabs() {
            this.default_tabs.map(item => {
                this.tabs.push({
                    title: item.title,
                    disabled: false,
                    is_active: false,
                    is_load: false,
                    index: item.index,
                    html: ''
                });
            });
        },
    },
    computed : {

        default_tabs() {
            let res = [
                {
                    "title": this.__t('MAIN_SETTINGS'),
                    "index": "employ_info",
                    is_active:true,
                },
                {
                    "title": this.__t('IMAGE'),
                    "index": "employ_image",
                    is_active:false,
                },

                {
                    "title": this.__t('TIPS'),
                    "index": "employ_tips",
                    is_active:false,
                },
            ];

            return res;
        },


        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }

            return "modal-dialog-right modal-lg";
        },
    }

}
</script>

<style scoped>

</style>
